import React, { ComponentType } from 'react'

import { WrapperWithHide } from './styled/WrapperWithHide'

interface Props {
  hide?: boolean
  testId?: string
}

export default function withHide<TProps>(
  Component: ComponentType<Omit<TProps, keyof Props>>,
): ComponentType<TProps & Props> {
  return function WithHide({ hide, testId, ...props }: TProps & Props) {
    return (
      <WrapperWithHide
        hide={hide}
        data-testid={testId}
      >
        <Component {...props} />
      </WrapperWithHide>
    )
  }
}
